<script setup lang="ts">
defineProps<{ visible: boolean }>();
</script>

<template>
  <div
    v-if="visible"
    role="status"
    aria-live="polite"
    data-testid="offline-banner"
    class="z-1 w-full flex items-center justify-center gap-2 px-4 pt-safe-offset-2 pb-2 bg-red-300 text-white text-xs font-semibold text-center pointer-events-none"
  >
    <span>{{ $t("app.offline.warning") }}</span>
  </div>
</template>
